<template>
    <div>
    <h3 class="mt-4">{{ $t("bom.electricProtection") }}</h3>
    <b-row style="height: 100%">
    <b-col sm="6" lg="5" xl="3">
    <b-form-group>
      <b-form-checkbox
        v-model="prewired"
        @click="prewired = !prewired"
        switch
        size="lg"
        class="form-type mb-2 mt-3"
      >{{ $t("prewired.prewired") }}</b-form-checkbox>
    </b-form-group>
    <b-alert v-if="prewired && configuration.columnType == 'XXS4'" variant="warning" show>{{ $t('prewired.onlySinglePhaseWarning', {columnType: configuration.columnType}) }}</b-alert>
    <hr />
    <b-form-group v-if="prewired">
      <template #label>{{ $t('prewired.fusingType.fusingType') }}
        <span
          v-b-tooltip.hover
          :title="$t('prewired.fusingType.tooltip')"
        >
          <font-awesome-icon
            class="form-icon ml-1"
            icon="question-circle"
          />
        </span>
      </template>
      <b-form-select
        v-model="fusingType"
        :options="fuseTypeOptions"
      />
    </b-form-group>

    <b-form-group v-if="prewired && fusingType != 'SELF'">
      <template #label>{{ $t('prewired.wiringType.wiringType') }}
        <span
          v-b-tooltip.hover
          :title="$t('prewired.wiringType.tooltip')"
        >
          <font-awesome-icon
            class="form-icon ml-1"
            icon="question-circle"
          />
        </span>
      </template>
      <b-form-select
        v-model="wiringType"
        :options="wiringTypeOptions"
      />
    </b-form-group>

    <b-form-group v-if="prewired && fusingType == 'RCD'">
      <template #label>{{ $t('prewired.feedInCurrent') }}
        <span
          v-b-tooltip.hover
          :title="$t('prewired.feedInCurrentTooltip')"
        >
          <font-awesome-icon
            class="form-icon ml-1"
            icon="question-circle"
          />
        </span>
      </template>
      <b-form-select
        v-model="feedInCurrent"
        :options="feedInTypes"
      />
    </b-form-group>
    </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      feedInCurrent: null,
      fusingType: "SELF",
      wiringType: "COLLECTIVE",
      prewired: false
    }
  },
  computed: {
    feedInTypes() {
      return [16, 32, 63].map(x => ({ value: x, text: `${x} A` }))
    },
    fuseTypeOptions() {
      return ["SELF", "RCD", "LINEPROTECTION"].map((id) => ({
        value: id,
        text: this.$t(`prewired.fusingType.${id}`),
      }));
    },
    wiringTypeOptions() {
      return ["SINGLE", "COLLECTIVE"].map((id) => ({
        value: id,
        text: this.$t(`prewired.wiringType.${id}`),
      }));
    },
    configuration() {
      return this.$store.state.configurations.configuration
    }
  },
  methods: {
    async save() {
      this.$store.commit("configurations/setConfiguration", {
        configuration: {
          ...this.configuration,
          prewired: this.prewired,
          electricProtection:
            this.prewired && this.fusingType != "SELF"
              ? {
                rcd: this.fusingType == "RCD",
                wiringType: this.wiringType,
                feedInCurrent:
                  this.fusingType == "RCD" ? this.feedInCurrent : null,
              }
              : null,
        },
      });
    }
  },
  created() {
    this.prewired = this.configuration.prewired;
    this.fusingType = this.configuration.electricProtection
      ? this.configuration.electricProtection.rcd == true
        ? "RCD"
        : "LINEPROTECTION"
      : "SELF";
    this.wiringType = this.configuration.electricProtection
      ? this.configuration.electricProtection.wiringType
      : "COLLECTIVE";
    this.feedInCurrent = this.configuration.electricProtection && this.configuration.electricProtection.rcd
        ? this.configuration.electricProtection.feedInCurrent : 16

    this.$watch(() => this.$data, this.save, { deep: true })
  }
}
</script>
